export default "__VITE_ASSET__C$nTcQo0__"